import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { API_URL } from 'common/constants/api-url';
import {
  AiVariant,
  RequestAiVariantsBody,
  RequestContextHistoryBody,
  RequestNewAiVariantBody,
} from 'modules/mel-ai';

import { getBaseQuery } from '../base-query';

export const melApiSlice = createApi({
  baseQuery: getBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    fetchAiVariant: builder.query<AiVariant, number>({
      query: (variantId) => ({
        url: `/ai-variants/${variantId}`,
      }),
    }),
    fetchAiVariants: builder.mutation<AiVariant[], RequestAiVariantsBody>({
      query: (body) => ({
        body,
        method: 'POST',
        url: '/ai-variants/search',
      }),
    }),
    fetchContextHistory: builder.mutation<any, RequestContextHistoryBody>({
      query: (body) => ({
        body,
        method: 'POST',
        url: '/ai-variants/comments/search',
      }),
    }),
    requestNewVariant: builder.mutation<any, RequestNewAiVariantBody>({
      query: (body) => ({
        body,
        method: 'POST',
        url: '/ai-variants/request-ai-variants',
      }),
    }),
    selectAiVariant: builder.mutation<any, number>({
      query: (variantId) => ({
        method: 'PUT',
        url: `/ai-variants/${variantId}`,
      }),
    }),
  }),
  reducerPath: 'melAi',
});
